var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsernameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style=fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88372 0C4.23119 0 2.73685 0.413017 1.65221 1.42018C0.557286 2.4369 0 3.94675 0 5.88372V13.0465C0 14.9835 0.557286 16.4933 1.65221 17.5101C2.73685 18.5172 4.23119 18.9302 5.88372 18.9302H16.1163C17.7688 18.9302 19.2632 18.5172 20.3477 17.5101C21.4427 16.4933 22 14.9835 22 13.0465V5.88372C22 3.94675 21.4427 2.4369 20.3477 1.42018C19.2632 0.413017 17.7688 0 16.1163 0H5.88372ZM18.3966 5.74282C18.7319 5.48367 18.7937 5.00169 18.5345 4.66631C18.2755 4.33092 17.7935 4.26913 17.4581 4.52829L11.782 8.9142C11.3214 9.27019 10.6785 9.27019 10.2178 8.9142L4.54182 4.52829C4.20643 4.26913 3.72447 4.33092 3.46531 4.66631C3.20615 5.00169 3.26794 5.48367 3.60333 5.74282L9.2794 10.1288C10.2928 10.9118 11.7071 10.9118 12.7205 10.1288L18.3966 5.74282Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsernameIcon);
export default __webpack_public_path__ + "static/media/UsernameIcon.dada2930a71bf5c28b7231070a2cb696.svg";
export { ForwardRef as ReactComponent };